module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-react-i18next/gatsby-browser.js'),
      options: {"plugins":[],"localeJsonSourceName":"locales","languages":["ar","de","en","es","fr","it","nl","zh"],"fileName":"common","siteUrl":"https://www.playfactile.com","trailingSlash":"always","i18nextOptions":{"fallbackLng":"en","supportedLngs":["ar","de","en","es","fr","it","nl","zh"],"interpolation":{"escapeValue":false},"keySeparator":".","nsSeparator":false}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
